import ImageBanner from '@deltek/specification-client/core/Typography/ImageBanner'
import { makeStyles } from '@material-ui/core/styles'
import { KNOWLEDGEPOINT_CDN_URL } from 'bpm/shared/utils/urlUtils'
import React from 'react'

const useStyles = makeStyles({
    bannerContainer: {
        marginLeft: -24,
        marginRight: -24,
        marginTop: 2,
    },
})

export interface BanneredPageProps {
    image?: string
    heading: string
    subtext?: string
}

const BanneredPage: React.FC<BanneredPageProps> = ({
    image = `${KNOWLEDGEPOINT_CDN_URL}/sample_banner.png`,
    heading,
    subtext,
    children,
}) => {
    const classes = useStyles()
    return (
        <>
            <div className={classes.bannerContainer}>
                <ImageBanner
                    width="100%"
                    image={image}
                    heading={heading}
                    subtext={subtext}
                />
            </div>
            {children}
        </>
    )
}

export default BanneredPage
